<a *ngIf="isValidUrl"
  [href]="value" target="_blank"
  class="url-link"
  (click)="$event.stopPropagation()">
  <mat-icon class="url-link__icon" fontSet="material-icons-outlined">link</mat-icon>
  {{value || '—'}}
</a>
<span *ngIf="!isValidUrl">{{value || '—'}}</span>
